/* global Selectize */
import { onPageLoad } from '@/js/modules/page_load';

// Selectize plugins register when this module is imported, which is before any ready handler
// builds a selectize, and again after a Turbo visit, whose re-run CDN Selectize script comes back
// without plugins. Callers import the plugin's name constant, so the dependency is explicit.

// Keeps the dropdown open, for filters that show their options inline.
export const INLINE_SELECTIZE = 'inline_selectize';
// Keeps a "new" option in the results when a search matches nothing.
export const SEARCH_DEFAULT_RESULT = 'search_default_result';
// Adds a "show all" option to an ajax-loaded dropdown.
export const SHOW_ALL_OPTION = 'show_all_option';
// Adds a button that clears the search input.
export const CLEAR_SEARCH_BUTTON = 'clear_search_button';

onPageLoad(() => {
  if (typeof Selectize !== 'undefined') {
    Selectize.define(INLINE_SELECTIZE, function () {
      const self = this;

      this.on('initialize', function () {
        self.open();
      });

      this.close = (function () {
        return function () {};
      })();
    });

    Selectize.define(SEARCH_DEFAULT_RESULT, function (options) {
      const self = this;
      this.search = (() => {
        const original = self.search;
        const options = self.options;
        return function (...args) {
          const result = original.apply(this, args);
          if (result.items.length < 1 && options.new) {
            result.items.push({ score: 1, id: 'new' });
            result.total = 1;
          }
          return result;
        };
      })();
    });

    Selectize.define(SHOW_ALL_OPTION, function () {
      const self = this;

      const getAllOptionForType = () => {
        const type = self.$input.data('param');
        if (!type) {
          return null;
        }

        if (type === 'client_id' || type === 'client_ids') {
          return {
            id: 'all',
            name: 'All Clients',
            display_name: 'All Clients',
          };
        } else if (type === 'project_id' || type === 'project_ids') {
          return {
            id: 'all',
            name: 'All Projects',
          };
        }
        return null;
      };

      self.refreshOptions = (function () {
        const original = self.refreshOptions;
        return function (...args) {
          const result = original.apply(this, args);
          const hasQuery = self.lastQuery && self.lastQuery.trim() !== '';

          if (!hasQuery) {
            const allOption = getAllOptionForType();
            if (allOption && !self.options[allOption.id]) {
              self.addOption(allOption);
            }
            if (allOption && self.$dropdown) {
              const $allOption = self.$dropdown.find(`[data-value="${allOption.id}"]`);
              if ($allOption.length) {
                const $dropdownContent = self.$dropdown.find('.selectize-dropdown-content');
                $dropdownContent.prepend($allOption);
              }
            }
          } else {
            const allOption = getAllOptionForType();
            if (allOption && self.$dropdown) {
              const $allOption = self.$dropdown.find(`[data-value="${allOption.id}"]`);
              $allOption.remove();
            }
          }

          return result;
        };
      })();
    });

    Selectize.define(CLEAR_SEARCH_BUTTON, function (options) {
      const self = this;
      self.setup = (function () {
        const original = self.setup;
        return function () {
          original.apply(self);
          const $input = self.$control_input;
          const $control = self.$control;

          $input.on('keyup', function () {
            const val = $input.val();
            let $clearButton = $control.find('.selectize-control--clear-search');

            if (val === '') {
              $clearButton.remove();
            } else if ($clearButton.length === 0) {
              $clearButton = $(
                '<a class="selectize-control--clear-search" href="#"><i class="fa-solid fa-circle-xmark"></i></a>'
              );
              $clearButton.insertAfter($input);

              $clearButton.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                self.setTextboxValue('');
                self.refreshOptions();
                $input.trigger('keyup');
              });
            }
          });
        };
      })();
    });
  }
});
